import { combineReducers } from "redux";

import {
  constants as ReportFormConstants,
  reducer as ReportFormReducer
} from "./modules/ReportForm";

import {
  constants as ReportConstants,
  reducer as ReportReducer
} from "./modules/Report";

import {
  constants as MerchantConstants,
  reducer as MerchantReducer
} from "./modules/Merchant";

import {
  constants as UserConstants,
  reducer as UserReducer
} from "./modules/User";

import {
  constants as AdminConstants,
  reducer as AdminReducer
} from "./modules/Admin";

import {
  constants as AnalyticsConstants,
  reducer as AnalyticsReducer
} from "./modules/Analytics";

import {
  constants as AnalyticsMetricConstants,
  reducer as AnalyticsMetricReducer
} from "./modules/AnalyticsMetric";

import {
  constants as StoreVisitsConstants,
  reducer as StoreVisitsReducer
} from "./modules/StoreVisits";

export default combineReducers({
  [ReportFormConstants.NAME]: ReportFormReducer,
  [ReportConstants.NAME]: ReportReducer,
  [MerchantConstants.NAME]: MerchantReducer,
  [UserConstants.NAME]: UserReducer,
  [AdminConstants.NAME]: AdminReducer,
  [AnalyticsConstants.NAME]: AnalyticsReducer,
  [AnalyticsMetricConstants.NAME]: AnalyticsMetricReducer,
  [StoreVisitsConstants.NAME]: StoreVisitsReducer
});



// WEBPACK FOOTER //
// ./client/reducer.js